import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let CursorPointer = (props) => (
  <SvgIcon {...props}>
    <path d="M4,0 L20.088562,11.3078003 L14.2474976,12.9793091 L18.1539917,21.0842896 L12.7589722,23.7384644 L8.78991699,15.656311 L4,19.4770508 L4,0 Z M6,4 L6.00170898,15.4602051 L9.48181152,12.6871338 L13.6333618,21.2539062 L15.4642944,20.2895508 L11.3736572,11.7994995 L15.4668579,10.6425781 L6,4 Z"/>
  </SvgIcon>
);
CursorPointer = pure(CursorPointer);
CursorPointer.displayName = 'CursorPointer';
CursorPointer.muiName = 'SvgIcon';

export default CursorPointer;
